export const integerRateRule = (required = false) => ({
  validator(rule, value, callback) {
    if (value === '' || value === null || value === undefined) {
      if (required) {
        callback(new Error('请输入比例'))
      } else {
        callback()
      }
      return
    }
    if (!/^\d{1,3}$/.test(String(value))) {
      callback(new Error('只能输入整数，最多3位'))
      return
    }
    callback()
  },
  trigger: 'blur',
})

export function sanitizeIntegerInput(value, maxLength = 3) {
  return String(value == null ? '' : value).replace(/\D/g, '').slice(0, maxLength)
}
